import { useState } from "react";
import { Badge, Button, Col, Container, Form, Row } from "react-bootstrap";
// import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { RxSlider } from "react-icons/rx";
import { TfiCheckBox } from "react-icons/tfi";
import { PiPasswordBold } from "react-icons/pi";
import { FiLink } from "react-icons/fi";
import { GoFile, GoNumber } from "react-icons/go";
import { FaTrashAlt } from "react-icons/fa";
import { AiOutlineEdit } from "react-icons/ai";
import { TbCalendarTime } from "react-icons/tb";
import {
  MdOutlineLinearScale,
  MdOutlineMailOutline,
  MdOutlineTextFields,
} from "react-icons/md";
import { IoRadioButtonOnOutline, IoTimeOutline } from "react-icons/io5";
import {
  BsCalendar2Month,
  BsCalendar4Week,
  BsCalendarDate,
  BsTelephone,
  BsTextareaResize,
} from "react-icons/bs";
import { RiDropdownList, RiSeparator } from "react-icons/ri";
import { LuHeading } from "react-icons/lu";

/* =========================
   Field Card
========================= */
const FieldCard = ({ field, onDelete }) => {
  const { id, label, type, icon: Icon } = field;

  return (
    <div className="border bg-light rounded-1 p-3 mb-3 position-relative">
      <Form.Group>
        <div className="d-flex justify-content-between align-items-center mb-2">
          <Form.Label className="m-0 fw-bold">
            {label} <span className="text-danger">*</span>
          </Form.Label>

          <div className="d-flex gap-2">
            <button className="icon-btn">
              <AiOutlineEdit />
            </button>
            <button className="icon-btn danger" onClick={() => onDelete(id)}>
              <FaTrashAlt />
            </button>
          </div>
        </div>

        {![
          "radio",
          "checkbox",
          "range",
          "textarea",
          "heading",
          "select",
          "separator",
          "scale",
        ].includes(type) && (
          <Form.Control type={type} placeholder={`Enter ${label}`} />
        )}

        {type === "radio" && (
          <>
            <Form.Check type="radio" label="Option 1" />
            <Form.Check type="radio" label="Option 2" />
          </>
        )}

        {type === "checkbox" && (
          <>
            <Form.Check type="checkbox" label="Option 1" />
            <Form.Check type="checkbox" label="Option 2" />
          </>
        )}

        {type === "select" && (
          <>
            <Form.Select style={{ fontSize: 12 }}>
              <option>Option 1</option>
              <option>Option 2</option>
            </Form.Select>
          </>
        )}

        {type === "range" && <Form.Range />}
        {type === "separator" && <hr />}
        {type === "scale" && <hr />}

        {type === "textarea" && (
          <Form.Control
            as={`textarea`}
            rows={3}
            placeholder={`Enter ${label}`}
          />
        )}
      </Form.Group>

      <Badge
        className="position-absolute top-0 start-0 rounded-1 translate-middle-y ms-2"
        style={{ width: 80 }}
      >
        <Icon className="me-1" /> {label}
      </Badge>
    </div>
  );
};

/* =========================
   Main Form Editor
========================= */
const FormEditor = ({ setOpenHistory }) => {
  const [fields, setFields] = useState([]);
  // const [fields, setFields] = useState([]);
  // const [fields, setFields] = useState([]);

  const FIELD_TYPES = [
    { label: "Heading", type: "heading", icon: LuHeading },
    { label: "Text", type: "text", icon: MdOutlineTextFields },
    { label: "Textarea", type: "textarea", icon: BsTextareaResize },
    { label: "Email", type: "email", icon: MdOutlineMailOutline },
    { label: "Password", type: "password", icon: PiPasswordBold },
    { label: "URL", type: "url", icon: FiLink },
    { label: "Number", type: "number", icon: GoNumber },
    { label: "Tel", type: "tel", icon: BsTelephone },
    { label: "Week", type: "week", icon: BsCalendar4Week },
    { label: "Date", type: "date", icon: BsCalendarDate },
    { label: "Time", type: "time", icon: IoTimeOutline },
    { label: "Date Time", type: "datetime-local", icon: TbCalendarTime },
    { label: "Month Year", type: "month", icon: BsCalendar2Month },
    { label: "File", type: "file", icon: GoFile },
    { label: "Radio", type: "radio", icon: IoRadioButtonOnOutline },
    { label: "Checkbox", type: "checkbox", icon: TfiCheckBox },
    { label: "Dropdown", type: "select", icon: RiDropdownList },
    { label: "Range", type: "range", icon: RxSlider },
    { label: "Scale", type: "scale", icon: MdOutlineLinearScale },
    { label: "Separator", type: "separator", icon: RiSeparator },
  ];

  const addField = (field) => {
    setFields((prev) => [
      ...prev,
      {
        ...field,
        id: Date.now().toString(),
      },
    ]);
  };

  const deleteField = (id) => {
    setFields((prev) => prev.filter((f) => f.id !== id));
  };

  const onDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(fields);
    const [moved] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, moved);

    setFields(items);
  };

  return (
    <Container fluid className="border-top">
      <Row>
        <Col
          md={8}
          className="border-end overflow-auto"
          style={{ height: "calc(100vh - 97px)" }}
        >
          {fields.length === 0 && (
            <div
              className="hstack justify-content-center text-muted"
              style={{ height: "calc(100vh - 171px)" }}
            >
              Click fields from the right toolbar to add them
            </div>
          )}
          <div className="mt-3">
            {/* <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="form-fields">
                {(provided) => (
                  <div ref={provided.innerRef} {...provided.droppableProps}>
                    {fields.map((field, index) => (
                      <Draggable
                        key={field.id}
                        draggableId={field.id}
                        index={index}
                      >
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <FieldCard field={field} onDelete={deleteField} />
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext> */}

            {fields.length > 0 && (
              <div className="d-flex justify-content-end gap-2 my-3">
                <Button
                  size="sm"
                  variant="light"
                  onClick={() => setOpenHistory?.("formEntry")}
                >
                  Preview
                </Button>
                <Button size="sm">Save</Button>
              </div>
            )}
          </div>
        </Col>

        <Col
          md={4}
          className="overflow-auto p-0"
          style={{ height: "calc(100vh - 97px)" }}
        >
          <Container fluid className="p-3">
            <Row className="g-2">
              {FIELD_TYPES.map((field) => (
                <Col
                  xl={4}
                  lg={6}
                  md={6}
                  sm={6}
                  xs={12}
                  key={field.label}
                  className="d-flex"
                >
                  <button
                    type="button"
                    className="icon-btn d-flex flex-column align-items-center justify-content-center w-100 h-100 px-2 py-3"
                    onClick={() => addField(field)}
                  >
                    <field.icon size={20} />
                    <span className="small mt-1">{field.label}</span>
                  </button>
                </Col>
              ))}
            </Row>
          </Container>
        </Col>
      </Row>
    </Container>
  );
};

export default FormEditor;
